/*
Usage Instructions:

Include this javascript file in the theme.liquid file. 

Example on Dawn Theme:
{%- if settings.cart_type == 'drawer' -%}
    {%- render 'cart-drawer' -%}

  <script src="{{ 'skio-cart-options.js' | asset_url }}" type="module"></script>
{%- endif -%}

Then be sure to include the <skio-cart-options> element in your cart file. Whether that be liquid or javascript based. 

Example on Dawn Theme:

<td style="grid-column: 2 / 5; padding-top: 0;"> 
  <skio-cart-options item='{{ item | json }}' line='{{ forloop.index }}'></skio-cart-options>
</td>

You can pass information to the component by using properties or even by using javascript to set the properties: document.querySelector('skio-cart-options').item = {}; 

Ensure the cart is properly updated after the user selects a new selling plan by updating the function updateLineItem in this file to perform an update action to the cart. 
As of now this is built to be used with the Section Rendering API, but can be used with any AJAX cart or setup with some tweaking.
*/

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/all/lit-all.min.js';

const skioCartStyles = css`
  :host {
    font-size: 15px;
  }

  select {
    width: 100%;
    padding: .5rem 1rem;
    background: transparent;
    border: none;
    color: black;
    cursor: pointer;
    flex: 1;
    border: 1px solid #707070;
    border-radius: 0;
    font-family: inherit;

    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    white-space: nowrap;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 15px;
    background-repeat: no-repeat;
     font-family:Helvetica,Helvetica Neue,Arial,Lucida Grande,sans-serif;
    font-size:14px;
    border-radius:8px;
  }

  button {
    background: transparent;
    color: #000000;
    border: 2px solid #93D500;
    outline: none;
    cursor: pointer;
    padding: .5rem .5rem;
    width: 100%;
    transition: all 0.3s ease-in-out;
    font-weight: 500;
    letter-spacing: 0.5px;
    font-family:Helvetica,Helvetica Neue,Arial,Lucida Grande,sans-serif;
    font-size:16px;
    border-radius:8px;
    box-shadow: 0 0 8px  rgba(0, 0, 0, 0.2);
    
  }

  button:hover {
    background: #93D500;
    color: #ffffff;
  }

  button:focus-visible {
    outline: 2px solid black;
  }

  p {
    margin: 0;
  }

  p.sub-discount {
  display:none;
}
`;

export class SkioCartOptions extends LitElement {
  static styles = skioCartStyles;

  static properties = {
    item: { type: Object },
    line: { type: Number },

    product: { type: Object },
    selectedVariant: { type: Object },
    key: { type: String },
    
    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},

    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},

    discount_format: { type: String },

    moneyFormatter: {},

    currency: { type: String }
  };

  constructor() {
    super();

    this.item = null;
    this.line = null;

    this.product = null;
    this.selectedVariant = null;

    this.skioSellingPlanGroups = null;
    this.availableSellingPlanGroups = null;

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.discountFormat = 'percent';

    this.currency = 'USD';
    this.moneyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.currency,
    });
  }
 
  upgradeButton = () => {
     if(this.item.variant_title == '10 Count') return html`
      <button 
        class="skio-cart-upgrade" 
        type="button" 
        @click=${() => this.selectSellingPlan(this.availableSellingPlanGroups[0].selected_selling_plan.id) }>
         
        Subscribe & Save $5 <span style="display:none;">${ this.discount(this.availableSellingPlanGroups[0].selected_selling_plan).percent }</span>
      </button>
    `;
    else
       return html`
      <button 
        class="skio-cart-upgrade" 
        type="button" 
        @click=${() => this.selectSellingPlan(this.availableSellingPlanGroups[0].selected_selling_plan.id) }>
         
        Subscribe & Save $5/bag <span style="display:none;">${ this.discount(this.availableSellingPlanGroups[0].selected_selling_plan).percent }</span>
      </button>
    `;
  }
 
  // Subscribe & Save ${ this.discount(this.availableSellingPlanGroups[0].selected_selling_plan).percent }

   changeFrequency = () => {
    return html`
        <p class="sub-discount">Discount: ${ this.discount(this.selectedSellingPlan).percent }</p>

        <select @change=${ (e) => this.selectSellingPlan(e.target.value) }>
          <optgroup label="One Time Purchase">
            <option value="">One Time Purchase</option>
          </optgroup>
              
          ${ this.availableSellingPlanGroups ? this.availableSellingPlanGroups.map((group, index) => 
            html`
              <optgroup label="${ group.name } (Save ${ this.discount(group.selected_selling_plan).percent })">
                ${ group ? group.selling_plans.map((selling_plan) => 
                  html`
                  <option value="${ selling_plan.id }" .selected=${ selling_plan.id == this.selectedSellingPlan?.id }>
                    ${ group.name == 'Subscription' ? 'Delivery ' + selling_plan.name.toLowerCase() : selling_plan.name }
                  </option>
                  `
                ): ''}
              </optgroup>
            `
          ): ''}
        </select>
    `;
  }

  render() {
    if(!this.item || !this.product || !this.selectedVariant || this.product.requires_selling_plan) return;

    if(this.availableSellingPlanGroups) {
      return this.item.selling_plan_allocation ? this.changeFrequency() : this.upgradeButton();
    }
  }

  updated = (changed) => {
    if(changed.has('item') && this.item) {
      this.fetchProduct(this.item.handle);
    }

    if(changed.has('product') && this.product) {
      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      )

      console.log('item', this.item)

      this.selectedVariant = this.product.variants.find(variant => variant.id == this.item.variant_id);

      if(this.item.selling_plan_allocation) {
        let itemSellingPlanId = this.item.selling_plan_allocation.selling_plan.id;

        this.selectedSellingPlanGroup = this.skioSellingPlanGroups.find(group => group.selling_plans.find(selling_plan => selling_plan.id == itemSellingPlanId));
        this.selectedSellingPlan = this.selectedSellingPlanGroup.selling_plans.find(selling_plan => selling_plan.id == itemSellingPlanId);
      }
    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      //update availableSellingPlanGroups based on skioSellingPlanGroups and selectedVariant.id
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      )

      //update selectedSellingPlan value
      if (this.availableSellingPlanGroups.length) {
        //update each group with a default selected_selling_plan
        
        this.availableSellingPlanGroups.forEach((group => {
          group.selected_selling_plan = group.selling_plans[0];
        }));
      }
    }
  }

  log = (...args) => {
    args.unshift('%c[skio cart options]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio cart options]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLineItem() {    
    if(!this.line || !this.item) return;
    if(this.item.selling_plan_allocation?.selling_plan?.id == this.selectedSellingPlan?.id) return;

    const data = JSON.stringify({
      line: this.line,
      quantity: this.item.quantity,
      selling_plan: this.selectedSellingPlan ? this.selectedSellingPlan?.id : null,

      // Remove these two lines if the cart doesn't use the section rendering API
     
      // sections: this.getSectionsToRender().map((section) => section.section),
      // sections_url: window.location.pathname
    })

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: data
    })
    .then((response) => response.text())
    .then((state) => {
      Shopify.theme.jsAjaxCart.updateView();
          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

    })
  }
  
  // Update selected selling plan group; called on click of skio-group-container element
  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
  }

  // Update selected selling plan; called on change of skio-frequency select element
  selectSellingPlan(id) {
    if(!id) {
      this.selectedSellingPlanGroup = null;
      this.selectedSellingPlan = null;
      
      this.updateLineItem();
      return;
    }

    let group = this.availableSellingPlanGroups.find(group => group.selling_plans.find(selling_plan => selling_plan.id == id));
    let selling_plan = group.selling_plans.find(x => x.id == id);
    
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);

    this.updateLineItem();
  }

  // Formats integer value into money value
  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  // Calculates discount based on selling_plan.price_adjustments, returns { percent, amount } of selling plan discount
  discount(selling_plan) {
    if (!selling_plan)
      return { percent: '0%', amount: 0 }
    
    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;
    
    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round(
          (price * price_adjustment.value) / 100.0
        )
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(
          ((price_adjustment.value * 1.0) / price) * 100.0
        )}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round(
          (((price - price_adjustment.value) * 1.0) /
            price) *
            100.0
        )}%`
        discount.amount = price - price_adjustment.value
        break
    }
    
    return discount
  }

  fetchProduct = async(handle) => {
    let productCache = window.sessionStorage.skioCartProductCache ? JSON.parse(window.sessionStorage.skioCartProductCache) : [];
    let cachedProduct = productCache ? productCache.find(product => product.handle == handle) : null;
    
    if(cachedProduct) {
      this.product = cachedProduct;
    } else {
      await fetch(`/products/${ handle }.js`)
      .then((response) => response.json())
      .then((response) => {
        this.product = response;
        productCache.push(response);
        window.sessionStorage.skioCartProductCache = JSON.stringify(productCache);
      })
    }
  }
}

customElements.define('skio-cart-options', SkioCartOptions);